/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../src/app/document-hitlist/components/document-hitlist-grid.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '@angular/core/src/zone/ng_zone';
import * as import10 from '../../../../../src/app/document-hitlist/services/document-hitlist-config.service';
import * as import11 from 'ng2-translate/src/translate.service';
import * as import12 from './document-hitlist-grid.component.css.shim.ngstyle';
import * as import13 from '@angular/core/src/linker/query_list';
import * as import14 from '@angular/core/src/linker/element_ref';
export class Wrapper_DocumentHitlistGridComponent {
  /*private*/ _eventHandler:Function;
  context:import0.DocumentHitlistGridComponent;
  /*private*/ _changed:boolean;
  /*private*/ _changes:{[key: string]:any};
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  subscription0:any;
  subscription1:any;
  constructor(p0:any,p1:any,p2:any) {
    this._changed = false;
    this._changes = {};
    this.context = new import0.DocumentHitlistGridComponent(p0,p1,p2);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    this.context.ngOnDestroy();
    (this.subscription0 && this.subscription0.unsubscribe());
    (this.subscription1 && this.subscription1.unsubscribe());
  }
  check_documents(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.documents = currValue;
      this._changes['documents'] = new import1.SimpleChange(this._expr_0,currValue);
      this._expr_0 = currValue;
    }
  }
  check_columns(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.columns = currValue;
      this._changes['columns'] = new import1.SimpleChange(this._expr_1,currValue);
      this._expr_1 = currValue;
    }
  }
  check_isFullText(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.isFullText = currValue;
      this._changes['isFullText'] = new import1.SimpleChange(this._expr_2,currValue);
      this._expr_2 = currValue;
    }
  }
  check_isMobileBrowser(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.isMobileBrowser = currValue;
      this._changes['isMobileBrowser'] = new import1.SimpleChange(this._expr_3,currValue);
      this._expr_3 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) {
      if (changed) {
        this.context.ngOnChanges(this._changes);
        this._changes = {};
      }
      if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); }
    }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean,emit1:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.documentOpen.subscribe(_eventHandler.bind(view,'documentOpen'))); }
    if (emit1) { (this.subscription1 = this.context.documentOpenInNewWindow.subscribe(_eventHandler.bind(view,'documentOpenInNewWindow'))); }
  }
}
var renderType_DocumentHitlistGridComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_DocumentHitlistGridComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.DocumentHitlistGridComponent>;
  _DocumentHitlistGridComponent_0_3:Wrapper_DocumentHitlistGridComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DocumentHitlistGridComponent_Host0,renderType_DocumentHitlistGridComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'obpa-document-hitlist-grid',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_DocumentHitlistGridComponent0(this.viewUtils,this,0,this._el_0);
    this._DocumentHitlistGridComponent_0_3 = new Wrapper_DocumentHitlistGridComponent(this.injectorGet(import9.NgZone,this.parentIndex),this.injectorGet(import10.DocumentHitlistConfigService,this.parentIndex),this.injectorGet(import11.TranslateService,this.parentIndex));
    this.compView_0.create(this._DocumentHitlistGridComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._DocumentHitlistGridComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.DocumentHitlistGridComponent) && (0 === requestNodeIndex))) { return this._DocumentHitlistGridComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    if (this._DocumentHitlistGridComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange)) { this.compView_0.markAsCheckOnce(); }
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._DocumentHitlistGridComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const DocumentHitlistGridComponentNgFactory:import8.ComponentFactory<import0.DocumentHitlistGridComponent> = new import8.ComponentFactory<import0.DocumentHitlistGridComponent>('obpa-document-hitlist-grid',View_DocumentHitlistGridComponent_Host0,import0.DocumentHitlistGridComponent);
const styles_DocumentHitlistGridComponent:any[] = [import12.styles];
var renderType_DocumentHitlistGridComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.Emulated,styles_DocumentHitlistGridComponent,{});
export class View_DocumentHitlistGridComponent0 extends import2.AppView<import0.DocumentHitlistGridComponent> {
  _viewQuery_grid_0:import13.QueryList<any>;
  _el_0:any;
  _text_1:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DocumentHitlistGridComponent0,renderType_DocumentHitlistGridComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckOnce);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_grid_0 = new import13.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'table',new import3.InlineArray2(2,'id','obpa-grid'),(null as any));
    this._text_1 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._viewQuery_grid_0.reset([new import14.ElementRef(this._el_0)]);
    this.context.gridElementRef = this._viewQuery_grid_0.first;
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
}


// WEBPACK FOOTER //
// ./$$_gendir/src/app/document-hitlist/components/document-hitlist-grid.component.ngfactory.ts